import React, { useState } from "react";
import locationIcon from "../../../assets/icons/map.svg";
import phoneIcon from "../../../assets/icons/call.svg";
import envelopeIcon from "../../../assets/icons/mail.svg";
import question from "../../../assets/icons/question.svg";
import RequestForm from "components/RequestForm";

const ContactInfo = () => {
  const [openModal, setOpenModal] = useState(false);

  const infos = [
    {
      icon: question,
      title: "Request a property",
      dsc: ["Can’t find the home you are looking for?"],
    },
    {
      icon: phoneIcon,
      title: "Need assistance?",
      dsc: [
        {
          label: "Client Support:",
          link: "tel:+2348111707007",
          value: "+234 811 170 7007",
        },
        {
          label: "Host Support:",
          link: "tel:+2349118008008",
          value: "+234 911 800 8008",
        },
      ],
    },
    {
      icon: envelopeIcon,
      title: "Send us an email",
      dsc: [
        "You can shoot us an email at",
        {
          label: "",
          link: "mailto:hello@krent.space",
          value: "hello@krent.space",
        },
        "or",
        {
          label: "",
          link: "mailto:info@krent.space",
          value: "info@krent.space",
        },
      ],
    },
    {
      icon: locationIcon,
      title: "Visit us at our location",
      dsc: ["Visit our headquarters, H3 Bayview estate Ikate, Lekki Lagos"],
    },
  ];

  return (
    <div className="pb-3">
      <div className="container">
        <div className="row">
          {infos.map((item, index) => (
            <div
              key={index}
              className="col-12 col-md-6 col-lg-3 d-flex align-items-stretch mb-4"
            >
              <div className="bg-white border-0 rounded px-3 py-4 shadow-sm w-100 h-100">
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <img src={item.icon} alt={item.title} className="img-fluid" />
                </div>
                <div className="d-flex flex-column justify-content-center text-center">
                  <h6 className="fw-bold mb-2 fs-13">{item.title}</h6>
                  <p className="mb-0">
                    {item.dsc.map((line, i) =>
                      typeof line === "string" ? (
                        <span key={i} className="d-block">
                          {line}
                        </span>
                      ) : (
                        <span key={i} className="d-block">
                          {line.label && `${line.label} `}
                          <a
                            href={line.link}
                            className="text-primary fw-semibold"
                          >
                            {line.value}
                          </a>
                        </span>
                      )
                    )}
                    {item.title === "Request a property" && (
                      <>
                        <span
                          className="text-primary cursor-pointer"
                          onClick={() => setOpenModal(true)}
                        >
                          {" "}
                          Click here{" "}
                        </span>
                        <span>to request a property</span>
                      </>
                    )}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <RequestForm
        setRequestFormOpen={setOpenModal}
        requestFormOpen={openModal}
      />
    </div>
  );
};

export default ContactInfo;
